<div
  class="container-image-ar d-flex align-items-center justify-content-center w-100 {{ aspectRatio ? '' : 'h-100' }}"
  [style.aspectRatio]="aspectRatio ? aspectRatio : 'auto'"
>
  <img [src]="imageSrc()" loading="lazy" class="bg" />
  <img [src]="imageSrc()" (load)="isLoading.set(false)" class="image" loading="lazy" />
  <div
    class="position-absolute right-0 left-0 top-0 bottom-0 d-flex align-items-center justify-content-center"
    *ngIf="isLoading()"
  >
    <circular-spinner [iconClass]="'icon-64 text-success'"></circular-spinner>
  </div>
</div>
